module.exports = __webpack_public_path__ + "img/print.93cf126b.png";